import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { roleApi } from '../../services/role';

interface RoleState {
  selectedRole: any | null;
  filters: {
    sortBy: string | null;
    sortOrder: 'asc' | 'desc';
  };
  pagination: {
    page: number;
    limit: number;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: RoleState = {
  selectedRole: null,
  filters: {
    sortBy: null,
    sortOrder: 'desc',
  },
  pagination: {
    page: 1,
    limit: 10,
  },
  isLoading: false,
  error: null,
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setSelectedRole: (state, action: PayloadAction<any | null>) => {
      state.selectedRole = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<RoleState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.page = 1;
    },
    setPagination: (state, action: PayloadAction<Partial<RoleState['pagination']>>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearRole: (state) => {
      state.selectedRole = null;
      state.error = null;
    },
    resetFilters: (state) => {
      state.filters = {
        sortBy: null,
        sortOrder: 'desc',
      };
      state.pagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        roleApi.endpoints.getRoles.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        roleApi.endpoints.getRoles.matchFulfilled,
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        roleApi.endpoints.getRoles.matchRejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message || 'Помилка завантаження ролей';
        }
      );
  },
});

export const {
  setSelectedRole,
  setFilters,
  setPagination,
  setLoading,
  setError,
  clearRole,
  resetFilters,
} = roleSlice.actions;

export default roleSlice.reducer; 